import React, { FC, useMemo } from 'react';

import { EvFlexColumn, EvFlexRow, EvTitle } from '@evinced-private/ui-common';

import { AccessibilityCriticalIssuesChartContainer } from 'src/apps/dashboard/components/accessibility-critical-issues-chart/AccessibilityCriticalIssuesChartContainer';
import { AccessibilityCriticalIssuesStackedChartContainer } from 'src/apps/dashboard/components/accessibility-critical-issues-stacked-chart';
import { AccessibilityTrendsChartContainer } from 'src/apps/dashboard/components/accessibility-trends-chart/AccessibilityTrendsChartContainer';
import { DashboardChartWrapper } from 'src/apps/dashboard/components/dashboard-chart-wrapper';
import { DASHBOARD_LABELS } from 'src/common/labels/dashboard.labels';

import { normalizeIssuesToScoreDates } from './DashboardTemplateCharts.helpers';
import { DashboardTemplateChartsProps } from './DashboardTemplateCharts.types';

export const DashboardTemplateCharts: FC<DashboardTemplateChartsProps> = ({
	scoreQuery,
	dashboardQuery,
	variant
}) => {
	const scoreDataList = useMemo(() => scoreQuery.data?.scores ?? [], [scoreQuery.data?.scores]);

	const normalizedIssues = useMemo(
		() =>
			normalizeIssuesToScoreDates(
				scoreDataList,
				dashboardQuery.data?.dailyAllIssues ?? [],
				dashboardQuery.data?.dailyUniqueIssues ?? []
			),
		[scoreDataList, dashboardQuery.data?.dailyAllIssues, dashboardQuery.data?.dailyUniqueIssues]
	);

	return (
		<EvFlexColumn gap="LARGE" as="section">
			<EvTitle id="trends-heading" titleText={DASHBOARD_LABELS.ACCESSIBILITY_PERFORMANCE_TRENDS} />
			<EvFlexRow gap="XLARGE">
				<DashboardChartWrapper>
					<AccessibilityTrendsChartContainer
						scoreData={scoreDataList}
						isLoading={scoreQuery.isLoading}
						error={scoreQuery.error}
					/>
				</DashboardChartWrapper>
				<DashboardChartWrapper>
					{variant === 'stacked' ? (
						<AccessibilityCriticalIssuesStackedChartContainer
							data={normalizedIssues.dailyAllIssues}
							uniqueIssuesData={normalizedIssues.dailyUniqueIssues}
							isLoading={dashboardQuery.isLoading}
							error={dashboardQuery.error}
						/>
					) : (
						<AccessibilityCriticalIssuesChartContainer
							data={normalizedIssues.dailyAllIssues}
							uniqueIssuesData={normalizedIssues.dailyUniqueIssues}
							isLoading={dashboardQuery.isLoading}
							error={dashboardQuery.error}
						/>
					)}
				</DashboardChartWrapper>
			</EvFlexRow>
		</EvFlexColumn>
	);
};
